import { SET_ALERT } from './../../actionTypes'
export const setAlert = (open, type, message, duration) => {
  return { type: SET_ALERT, payload: { open, type, message, duration } }
}
